import React, { useState, useEffect } from "react";
import {  Row, Col } from "react-bootstrap";
import {
  Search,
 Info,
  PencilRuler,
  Paintbrush,
  Rocket,
  Users
} from "lucide-react";


import "../buidl.css";

function Timeline() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

//   const handleContextMenu = (e) => {
//     e.preventDefault(); // Disable right-click
//   };

   const tasks = [
    { name: "Research", start: 1, end: 2, color: "#6EC1E4" },
    { name: "Information architecture", start: 2, end: 3, color: "#A78BFA" },
    { name: "Wireframes", start: 3, end: 4, color: "#FBBF24"  },
    { name: "UI design", start: 4, end: 8, color:  "#34D399" },
    { name: "Prototyping", start: 8, end: 9, color:  "#F87171" },
    { name: "User testing", start: 9, end: 10, color: "#60A5FA" },
  ];

  const weeks = Array.from({ length: 10 }, (_, i) => i + 1);

  return (
    <div
      fluid
      className="container-section"
      style={{
        backgroundColor: "#272A38",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: isSmallScreen ? "auto" : "100vh",
        paddingBottom: isSmallScreen ? "5rem" : "auto",
        paddingTop: isSmallScreen ? "5rem" : "auto",
      }}
    >
       <div
      style={{
        backgroundColor: "#272A38",
        color: "#fff",
        padding: isSmallScreen ? "0.7rem" : "2rem",
        fontFamily: "jost, sans-serif",
        overflowX: "auto",
        width: "100%",
      }}
    >
      <Row>
        <Col xs={12} md={7}>
          <h2 style={{ fontWeight: "bold", fontSize: "2.5rem" }}>
            Project Timeline
          </h2>
          <p style={{ fontSize: "0.82rem" }}>
            A visual roadmap outlining key tasks, their durations, and when they occur within a project
          </p>
        </Col>
        <Col xs={12} md={5}></Col>
      </Row>
      <br />

      {isSmallScreen ? (
        // Mobile View: Cards
       <div>
    {tasks.map((task, index) => {
      // Define icon and color per task
      const iconMap = {
        "Research": { icon: Search, color: "#6EC1E4" },
        "Information architecture": { icon: Info, color: "#A78BFA" },
        "Wireframes": { icon: PencilRuler, color: "#FBBF24" },
        "UI design": { icon: Paintbrush, color: "#34D399" },
        "Prototyping": { icon: Rocket, color: "#F87171" },
        "User testing": { icon: Users, color: "#60A5FA" }
      };

      const { icon: IconComponent, color } = iconMap[task.name];

      return (
        <div
          key={index}
          style={{
            backgroundColor: "#2C3045",
            padding: "0.6rem",
            borderRadius: "10px",
            marginBottom: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "1rem"
          }}
        >
          {/* Icon Box */}
          <div
            style={{
              backgroundColor: `${color}22`, // Faded color using opacity
              padding: "0.5rem",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "50px",
              minHeight: "50px"
            }}
          >
            <IconComponent color={color} size={24} />
          </div>

          {/* Task Info */}
          <div style={{ marginTop: "0.3rem" }}>
            <h4 style={{ marginBottom: "0.4rem", fontSize: "1rem" }}>
              {task.name}
            </h4>
            <p style={{ fontSize: "0.85rem", color: "#ccc" }}>
              Week {task.start} - {task.end}
            </p>
          </div>
        </div>
      );
    })}
  </div>
      ) : (
        // Desktop View: Timeline
        <>
          <div
            style={{
              display: "flex",
              marginBottom: "0rem",
              borderBottom: "1px solid #444",
              paddingBottom: "1rem",
            }}
          >
            {weeks.map((week) => (
              <div
                key={week}
                style={{
                  flex: 1,
                  textAlign: "center",
                  fontSize: "0.81rem",
                  color: "#aaa",
                  minWidth: "60px",
                }}
              >
                Week {week}
              </div>
            ))}
          </div>

          <div style={{ position: "relative", height: `${tasks.length * 50}px` }}>
            {tasks.map((task, index) => (
              <div
                key={index}
                style={{
                  position: "absolute",
                  top: `${index * 50}px`,
                  left: `${(task.start - 1) * 10}%`,
                  width: `${(task.end - task.start + 1) * 10}%`,
                  backgroundColor: "#2C3045",
                  borderRadius: "10px",
                  padding: "0.75rem 1rem",
                  textAlign: "center",
                  fontSize: "0.81rem",
                  whiteSpace: "nowrap",
                  color:`${task.color}`,
                }}
              >
                {task.name}
              </div>
            ))}

            {/* Vertical dashed lines */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
              }}
            >
              {weeks.map((_, index) => (
                <div
                  key={index}
                  style={{
                    flex: 1,
                    borderLeft: "1px dashed #58649A",
                    minWidth: "60px",
                  }}
                ></div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
     
    </div>
  );
}

export default Timeline;